import gql from 'graphql-tag'
import { makesMutations } from 'data/graphql'

const providesIntegrationActivitySettingsUpsert = makesMutations({
  query: gql`
    mutation add(
      $target: JSON!
      $channelId: ID!
      $enabled: Boolean!
      $integrationId: ID!
    ) {
      integrationActivitySettingsAdd(
        input: {
          target: $target
          enabled: $enabled
          channelId: $channelId
          integrationId: $integrationId
        }
      ) {
        activitySettings {
          target
          enabled
        }
      }
    }
  `,
  mutationPropName: 'integrationActivitySettingsUpsert',
})

export default providesIntegrationActivitySettingsUpsert
